import React, { useEffect, useState } from "react";
import { Table, Spinner, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchContestDetails } from "store/actions/contestAction";

const tableHeaders = ["Fan Id", "Name", "Gender", "Email"];

const ContestFans = ({ contestId }) => {
  const dispatch = useDispatch();
  const { contestDetails } = useSelector((state) => state.contest);

  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleLoadMore = () => {
    setIsLoading(true);
    dispatch(
      fetchContestDetails({
        collectionName: "contest_enrollment",
        contestId,
        contestKey: "contest_id",
        userKey: "fan_id",
        lastVisible: contestDetails?.lastVisible,
      })
    ).finally(() => setIsLoading(false));
  };

  useEffect(() => {
    setIsFetching(true);
    dispatch(
      fetchContestDetails({
        collectionName: "contest_enrollment",
        contestId,
        contestKey: "contest_id",
        userKey: "fan_id",
      })
    ).finally(() => setIsFetching(false));
  }, []);

  return (
    <div className="p-0">
      {isFetching ? (
        <div className="text-center py-4 text-primary">
          <Spinner animation="border" size="md" />
        </div>
      ) : (
        <>
          <Table
            responsive
            className="table-centered table-nowrap rounded mb-0 border"
          >
            <thead className="thead-light">
              <tr>
                {tableHeaders?.map((header, index) => (
                  <th key={index} className="border-0">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {contestDetails?.data?.length > 0 ? (
                contestDetails?.data?.map((detail, index) => (
                  <tr key={index}>
                    <td className="border-0">
                      {detail?.userData?.fanID || "N/A"}
                    </td>
                    <td className="border-0 text-capitalize">
                      {detail?.userData?.name}
                    </td>
                    <td className="border-0 text-capitalize">
                      {detail?.userData?.gender}
                    </td>
                    <td className="border-0">{detail?.userData?.email}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={tableHeaders?.length}
                    className="text-center py-4"
                  >
                    No Fan
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          {contestDetails?.hasMore && (
            <div className="text-center py-2">
              <Button
                variant="primary"
                onClick={handleLoadMore}
                disabled={isFetching || isLoading}
                style={{ width: "100px", height: "40px", fontSize: "14px" }}
              >
                {isLoading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Load More"
                )}
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ContestFans;
